module.exports = __webpack_public_path__ + "img/3.486d3a90.jpg";